import HttpToolsAPI from '../../api/agents/httpTools';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isTesting: false,
  },
};

const getters = {
  getHttpTools: $state => $state.records,
  getHttpToolById: $state => id =>
    $state.records.find(t => t.id === Number(id)),
  getEnabledHttpTools: $state => $state.records.filter(t => t.enabled),
  getUIFlags: $state => $state.uiFlags,
};

const actions = {
  async fetchHttpTools({ commit }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await HttpToolsAPI.get();
      // The API returns { connectors, connector_types, available_tools }
      // but we want just the tools as http tools
      const tools = response.data.connectors || [];
      commit('SET_HTTP_TOOLS', tools);
      return tools;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async createHttpTool({ commit }, tool) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await HttpToolsAPI.create(tool);
      commit('ADD_HTTP_TOOL', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async updateHttpTool({ commit }, { id, ...data }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await HttpToolsAPI.update(id, data);
      commit('UPDATE_HTTP_TOOL', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async deleteHttpTool({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await HttpToolsAPI.delete(id);
      commit('REMOVE_HTTP_TOOL', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async testHttpTool({ commit }, { id, testParams }) {
    commit('SET_UI_FLAG', { isTesting: true });
    try {
      const response = await HttpToolsAPI.test(id, testParams);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isTesting: false });
    }
  },
};

const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_HTTP_TOOLS($state, tools) {
    $state.records = tools;
  },

  ADD_HTTP_TOOL($state, tool) {
    $state.records.push(tool);
  },

  UPDATE_HTTP_TOOL($state, tool) {
    const index = $state.records.findIndex(t => t.id === tool.id);
    if (index !== -1) {
      $state.records.splice(index, 1, tool);
    }
  },

  REMOVE_HTTP_TOOL($state, id) {
    $state.records = $state.records.filter(t => t.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
